export interface Category {
    id: string,
    name: string,
    thumbnail_url:string,
    displayCode:string,
    level: number,
    key: string
};

export type CategoryOf = "BUY" | "SELL" | "SERVICE" | "DEALER";